import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetRevieweeSkillActionsArgsType = GetRequestArgsType & {
  reviewCode: string;
  revieweeId: number;
  reviewSkillId: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PostRevieweeSkillActionArgsType = PostRequestArgsType<any> & {
  reviewCode: string;
  revieweeId: number;
  reviewSkillId: number;
};

export type DeleteRevieweeSkillActionArgsType = DeleteRequestArgsType & {
  reviewCode: string;
  revieweeId: number;
  reviewSkillId: number;
  revieweeSkillActionId: number;
};

export const apiFetchRevieweeSkillActions = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  reviewSkillId,
  errorConfig = {},
  callbacks = {},
}: GetRevieweeSkillActionsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.revieweeSkillActions({
        domain,
        reviewCode,
        revieweeId,
        reviewSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateRevieweeSkillAction = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  reviewSkillId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRevieweeSkillActionArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.revieweeSkillActions({
        domain,
        reviewCode,
        revieweeId,
        reviewSkillId,
      }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteRevieweeSkillAction = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  reviewSkillId,
  revieweeSkillActionId,
  errorConfig = {},
  callbacks = {},
}: DeleteRevieweeSkillActionArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.revieweeSkillActions({
        domain,
        reviewCode,
        revieweeId,
        reviewSkillId,
        revieweeSkillActionId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
